/** Error codes and their HTTP status (docs/05-api-contracts.md section 15). */
export const ERROR_CODES = {
    VALIDATION_FAILED: 400,
    AUTH_REQUIRED: 401,
    TOKEN_EXPIRED: 401,
    INVALID_CODE: 401,
    /** Another sign-in of the same kind took over this device's session (ADR 0030); the problem says when. */
    SIGNED_IN_ELSEWHERE: 401,
    PERMISSION_DENIED: 403,
    TENANT_REQUIRED: 403,
    STEP_UP_REQUIRED: 403,
    ENTERPRISE_NOT_VERIFIED: 403,
    ENTERPRISE_SUSPENDED: 403,
    AGREEMENT_ACCEPTANCE_REQUIRED: 403,
    COUNTRY_NOT_SERVED: 403,
    MARKET_NOT_OPEN: 403,
    KYB_NOT_ACTIVE: 403,
    CONTACT_REQUIRED: 403,
    SAME_RESOLVER: 403,
    CONTENT_ACCESS_REQUIRED: 403,
    NOT_FOUND: 404,
    FILE_REMOVED: 410,
    IDEMPOTENCY_KEY_REUSED: 409,
    DUPLICATE_REGISTRATION: 409,
    INVALID_TRANSITION: 409,
    QUOTE_EXPIRED: 409,
    QUOTE_SUPERSEDED: 409,
    SHOP_NOT_SELLING: 409,
    CASE_OPEN: 409,
    CONVERSATION_CLOSED: 409,
    WINDOW_CLOSED: 409,
    PAYMENTS_PAUSED: 409,
    FILE_NOT_CLEAN: 409,
    CLOSURE_BLOCKED: 409,
    NOT_READABLE: 409,
    LAST_ADMIN: 409,
    INVOICE_SETTINGS_REQUIRED: 409,
    VERSION_CONFLICT: 412,
    FILE_TOO_LARGE: 413,
    FILE_TYPE_NOT_ALLOWED: 415,
    PRODUCT_UNAVAILABLE: 422,
    PRODUCT_NOT_LIVE: 422,
    BELOW_MOQ: 422,
    EXCEEDS_OPEN_QUANTITY: 422,
    AMOUNT_EXCEEDS_HELD: 422,
    CURRENCY_NOT_ENABLED: 422,
    PAYMENT_METHOD_DISABLED: 422,
    RATE_LIMITED: 429,
    INTERNAL_ERROR: 500,
    PROVIDER_UNAVAILABLE: 502,
    MAINTENANCE: 503,
    FX_UNAVAILABLE: 503,
};
export const ERROR_CODE_LIST = Object.keys(ERROR_CODES);
export function statusOf(code) {
    return ERROR_CODES[code];
}
//# sourceMappingURL=codes.js.map